export default {
	init() {
		//var _this = this;
		if ( $('#billing_desea_factura').val() == 'Si' ) {
			$('.show_invoice').fadeIn();
		}
		else {
			$('.show_invoice').fadeOut();
			$('#billing_ruc').val('');
			$('#billing_razon_social').val('');
			$('#billing_address_invoice').val('');
		}
		$(document).on( 'change','#billing_desea_factura', function ( ) {
			if ( $(this).val() == 'Si' ) {
				$('.show_invoice').fadeIn();
			}
			else {
				$('.show_invoice').fadeOut();
				$('#billing_ruc').val('');
				$('#billing_razon_social').val('');
				$('#billing_address_invoice').val('');
			}	
		} );

		$( document ).on('change', '#deposito_banco', function() {
			if( $( '#deposito_banco' ).val() == '' ) {
				$('#deposito_numero').val('');
			}
			else {
				$('#deposito_numero').val( $( '#deposito_banco' ).val() + ' - ' );
			}
			$( '#deposito_numero' ).focus();
		} );
		$( '#misha_file' ).change( function() {
			if ( ! this.files.length ) {
				$( '#misha_filelist' ).empty();
			} else {
				$( '#misha_filelist' ).empty();
				const formData = new FormData();
				for (var x = 0; x < this.files.length; x++) {
					var file = this.files[x];
					$( '#misha_filelist' ).append( '<img src="' + URL.createObjectURL( file ) + '">' );
					formData.append( 'misha_file[]', file );
				}
				$.ajax({
					url: window.wc_checkout_params.ajax_url + '?action=mishaupload',
					type: 'POST',
					data: formData,
					contentType: false,
					enctype: 'multipart/form-data',
					processData: false,
					success: function ( response ) {
						$( 'input[name="misha_file_field"]' ).val( response );
					},
				});
			}
		} );
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/woocommerce_checkout.js